import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { BASE_URL } from '../../../environments/environment';
import { UsersService } from '../../services';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class SurveysService {

	constructor(
		private http: Http,
		private router: Router,
		private toastr: ToastrService,
		private userService: UsersService
	) { }

	//Surveys
	addSurvey(data) {
		return this.http.post(`${BASE_URL}surveys/add`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}

	deleteSurvey(id) {
		return this.http.delete(`${BASE_URL}surveys/${id}/delete`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	editSurvey(id, data) {
		return this.http.put(`${BASE_URL}surveys/${id}/edit`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	changeSurveyStatus(id, status, data) {
		return this.http.put(`${BASE_URL}surveys/${id}/status?status=${status}`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getAllSurveys(offset, filter_term) {
		return this.http.get(`${BASE_URL}surveys?offset=${offset}&filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getAllSurveysForUser(offset, filter_term) {
		return this.http.get(`${BASE_URL}surveys/assigned?offset=${offset}&filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSpecificSurvey(id) {
		return this.http.get(`${BASE_URL}surveys/${id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}
	

	//Survey questions
	addQuestion(id, data) {
		return this.http.post(`${BASE_URL}surveys/${id}/questions/add`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				return Observable.throw(err.json());
			});
	}

	deleteQuestion(id, question_id) {
		return this.http.delete(`${BASE_URL}surveys/${id}/questions/${question_id}/delete`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	editQuestion(id, question_id, data) {
		return this.http.put(`${BASE_URL}surveys/${id}/questions/${question_id}/edit`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	editQuestionPosition(id, data) {
		return this.http.put(`${BASE_URL}surveys/${id}/questions/position/edit`, data, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getAllQuestions(id, offset, filter_term) {
		return this.http.get(`${BASE_URL}surveys/${id}/questions?offset=${offset}&filter_term=${filter_term}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSpecificQuestion(id, question_id) {
		return this.http.get(`${BASE_URL}surveys/${id}/questions/${question_id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	//Survey statsitics
	getAllSurveySubmissions(id) {
		return this.http.get(`${BASE_URL}surveys/${id}/submissions`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSpecificSubmission(id, submission_id) {
		return this.http.get(`${BASE_URL}surveys/${id}/submissions/${submission_id}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	getSurveyStatistics(id, question_id, category) {
		return this.http.get(`${BASE_URL}surveys/${id}/questions/${question_id}/statistics?category=${category}`, this.getToken())
			.map(res => (<Response>res).json())
			.catch((err: Response) => {
				this._handleError(err);
				return Observable.throw(err.json());
			});
	}

	//Error function
	_handleError(error) {
		console.log(error);
		if (error.status === 401 || error.status === 455 || error.status === 403) {
			const clientObject = { client_id : localStorage.getItem('clientId') };
			if ( localStorage.getItem('clientId') !== null ) { 
			this.userService.autoLogin(clientObject).subscribe(
				response => {
					localStorage.setItem('securityToken', response.security_token);
					localStorage.setItem('clientId', response.client_id);
					this.toastr.warning('Vaš sigurnosni token je istekao, bit ćete automatski ponovo prijavljeni');
					setTimeout(() => {
						location.reload();
					}, 2000);
				},
				err => {
					console.log(err);
					if(err.error_msg){
						this.toastr.error(err.error_msg);
						this.router.navigate([`/login`]);
					}
				});
			} else {
				this.router.navigate([`/login`]);
			} 
		} else {
			return Observable.throw(error.json());
		}
	}

	//Header with token
	private getToken() {
		const token = localStorage.getItem('securityToken');
		if (token) {
			const headers = new Headers({
				'Content-Type': 'application/json',
				'Securitytoken': token,
			});
			return new RequestOptions({ headers: headers });
		}
	}
}



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/services/surveys/surveys.service.ts